import React, { Component } from 'react';
import { message } from 'antd';
import { querySaveCustom } from '@api/crm/custom';
import FormEdit from './FormProEdit';

class Edit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {},
    };
  }

  handSubmit = item => {
    const context = this;
    querySaveCustom(item).then(res => {
      if (res.statusCode === 200) {
        message.success('保存成功');
        context.props.router.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { dataInfo } = this.state;
    return <FormEdit handSubmit={this.handSubmit} data={dataInfo} />;
  }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/components/custom/base/PageProAdd.js